import * as Yup from "yup";

import axios from "axios";
import { apiConfig } from "../../../config";

const taskHandlers = {
  "Review next steps": () => {
    return new Promise((resolve, reject) => {
      resolve({ message: "Completed" });
    });
  },
  "Create registration form (new)": (
    prevousTask,
    token,
    { myFormData, updateHandler, task, user, selectedLandlord }
  ) => {
    myFormData["assigned_to"] = user.email;
    myFormData["operator_id"] = selectedLandlord.landlordid;

    return new Promise((resolve, reject) => {
      axios
        .post(`${apiConfig.hubspotApiUrl}companies/signups`, myFormData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          resolve({
            message: "Completed",
            ctaLink: {
              link: `/customers/registrations/edit/${response.data.id}`,
              label: "View New Draft",
            },
            data: response.data,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  "No action required": () => {
    return new Promise((resolve, reject) => {
      resolve({ message: "Completed" });
    });
  },
  "Create registration form (update)": (
    prevousTask,
    token,
    { myFormData, updateHandler, task, user, selectedLandlord }
  ) => {
    myFormData["assigned_to"] = user.email;
    myFormData["operator_id"] = selectedLandlord.landlordid;

    return new Promise((resolve, reject) => {
      axios
        .post(`${apiConfig.hubspotApiUrl}companies/signups`, myFormData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          resolve({
            message: "Completed",
            ctaLink: {
              link: `/customers/registrations/edit/${response.data.id}`,
              label: "View New Draft",
            },
            data: response.data,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const formConfig = {
  name: "customerRegistration__landlord",
  title: "NEW CUSTOMER REGISTRATION",
  steps: [
    {
      stepType: "input",
      title: "Customer Details",
      description:
        "Provide some details about the customer you wish to register",
      longDescription:
        "Provide some details about the customer you wish to register. We'll use these to firstly check if the customer already exists in Wavenet's systems.",
      fields: [
        {
          name: "company_name",
          label: "Company Name",
          confirmLabel: "Company Name",
          type: "text",
        },
        {
          name: "company_domain",
          label: "Company Domain Name",
          confirmLabel: "Domain Name",
          type: "text",
        },
        {
          name: "company_reg_number",
          label: "Company Registration Number",
          confirmLabel: "Company Registration Number",
          type: "text",
        },
      ],
      validationSchema: Yup.object().shape({
        company_name: Yup.string()
          .required("Company name is required")
          .nullable(false),
        company_domain: Yup.string().nullable(true),
        company_reg_number: Yup.number()
          .positive()
          .integer()
          .nullable(true)
          .typeError("Must be a number"),
      }),
    },
    // {
    //   stepType: "review",
    //   title: "Confirm Details",
    //   confirmationStep: true,
    //   description: "Review details and request new customer record",
    //   fields: [
    //     {
    //       name: "confirm",
    //       label: "Confirm that the below details are correct",
    //       type: "confirm",
    //       validation: null,
    //     },
    //   ],
    //   validationSchema: null,
    // },
    {
      stepType: "process",
      title: "Finish",
      description: "",
      confirmationStep: true,
      fields: [],
    },
  ],
  handleSubmit: async (
    formData,
    {
      setSubmissionStatus,
      userAccessToken,
      updateTaskStatus,
      setIsConfirmationNeeded,
      isConfirmed,
    }
  ) => {
    const tasks = [
      {
        name: "Review next steps",
        status: "pending",
        description:
          "See below for the next steps. If you're happy to proceed, click the button below.",
        continueText: "Create Registration Form",
      },
      {
        name: "Create registration form (new)",
        description:
          "No matching customers were found in Wavenet's systems. We'll open a new customer registration form to register the customer details in the CRM.",
        status: "pending",
      },
    ];

    setIsConfirmationNeeded(true);

    setSubmissionStatus({
      isLoading: true,
      tasks: tasks.map((task) => ({ ...task, status: task.status })),
    });

    const firstTask = tasks[0];
    const handler = taskHandlers[firstTask.name];
    updateTaskStatus(firstTask.name, "loading", null, "");

    try {
      const result = await handler(formData, userAccessToken);
      updateTaskStatus(
        firstTask.name,
        "succeeded",
        result.message,
        JSON.stringify(result.manifest, null, 2),
        result.ctaLink
      );

      // if (isConfirmed) {
      //   tasks.slice(1).forEach((task) => {
      //     updateTaskStatus(task.name, "loading", null, null);

      //     setTimeout(() => {
      //       updateTaskStatus(
      //         task.name,
      //         "succeeded",
      //         "Completed configuration successfully",
      //         {}
      //       );
      //     }, 5000);
      //   });
      // }
    } catch (error) {
      updateTaskStatus(
        firstTask.name,
        "failed",
        error.message,
        null,
        error.ctaLink
      );
    }
  },
  executeNextTask: async ({
    helpers,
    submissionStatus,
    taskIndex,
    setSubmissionStatus,
  }) => {
    const {
      updateTaskStatus,
      userAccessToken,
      myFormData,
      user,
      selectedLandlord,
    } = helpers;
    const task = submissionStatus.tasks[taskIndex];
    const previousTask = submissionStatus.tasks[taskIndex - 1];
    const handler = taskHandlers[task.name];
    updateTaskStatus(task.name, "loading", null, "");
    try {
      const result = await handler(previousTask.payload, userAccessToken, {
        task: task,
        updateHandler: updateTaskStatus,
        submissionStatusHandler: setSubmissionStatus,
        submissionStatus: submissionStatus,
        myFormData: myFormData,
        user: user,
        selectedLandlord: selectedLandlord,
      });
      updateTaskStatus(
        task.name,
        "succeeded",
        result.message,
        result.payload,
        result.ctaLink
      );
    } catch (error) {
      updateTaskStatus(
        task.name,
        "failed",
        error.message,
        error.payload,
        error.ctaLink
      );
    }
  },
  executeAllTasks: async ({
    helpers,
    submissionStatus,
    setSubmissionStatus,
  }) => {
    for (
      let i = submissionStatus.tasks.findIndex(
        (task) => task.status === "pending"
      );
      i < submissionStatus.tasks.length;
      i++
    ) {
      await formConfig.executeNextTask({
        helpers,
        submissionStatus,
        taskIndex: i,
        setSubmissionStatus,
      });
    }
  },
};

export default formConfig;
